/**
 * client/wrapper type for the PreChat widget on parent/page
 */
import BaseWidgetClient from '../core/BaseWidgetClient';
import WidgetTypes from '../core/enums/WidgetTypes';
import TempCache from '../core/enums/TempCache';
import PreChatAnimator from '../core/animators/PreChatAnimator';
import DropDownPositioner from '../core/positioners/DropDownPositioner';
import { PreChatMessageAnimation } from '../core/enums/Enum';
import addStyleText from '../core/hooks/addStyleText';
import getStyle from '../core/hooks/getStyle';
import GlobalVariables from '../core/GlobalVariables';
import getStyleForIframe from '../core/hooks/getStyleForIframe';
import WidgetStates from '../core/hooks/WidgetStates';
import createNS from '../core/createNs';
import logIt from '../../logIt';

export default function RegisterPreChat() {
    const PreChat = class extends BaseWidgetClient {
        constructor(options) {
            if (!options.preChat) {
                return;
            }
            super(
                Object.assign(options, {
                    widget: WidgetTypes.PreChat
                })
            );
            this.animator = new PreChatAnimator(this.options, this.DOM);
            this.positioner = new DropDownPositioner(this.options);
            this.ready();
        }

        ready() {
            super.ready();
            const me = this;
            this.subscribe('prechat-auto-resizing', (args) => {
                try {
                    if (!me.options.isPreChatRoundedTheme) {
                        return;
                    }
                    const closeButton = {
                        height:
                            me.options.preChatMessageAnimation ===
                                PreChatMessageAnimation.MobileStacking
                                ? 30
                                : 0, // 30px for closebutton height else 0px
                        isCloseButtonSupported:
                            me.options.preChatMessageAnimation ===
                            PreChatMessageAnimation.MobileStacking,
                        padding: 15 /* increased from 5px to 15px as it was hard to press small CLOSE Button */
                    };
                    const padding = 40; // padding and shadow
                    const extraHeightForSingleMsg = 5;
                    const extraHeightForStackedMsgs = 30;
                    // getting the prechat Height/Width...
                    const PreChatHeight =
                        ApexChat.PreChatIconDimensions.Height + padding + closeButton.height;
                    const PreChatWidth = ApexChat.PreChatIconDimensions.Width + padding;
                    // getting iframe
                    const iframe = document.getElementById(me.iframeId);
                    // Hide All messages on CLOSE Press
                    const allAppearedMessages = iframe.contentDocument.querySelector(
                        '.apexchat_prechat_message_bubble'
                    );
                    if (args.hideCloseButton && allAppearedMessages) {
                        allAppearedMessages.style.display = 'none'; // hiding all messages..
                    }
                    const addedHeight = args.isSingleMsg
                        ? extraHeightForSingleMsg
                        : extraHeightForStackedMsgs; // incase of Single msg 5px, otherwise 30px
                    // expected height formula for giving to IFRAME
                    let expectedHeight =
                        (args.currentMsgHeight || 0) /* height of current message */ +
                        (args.prevMsgHeight ||
                            0) /* If prev. msg was not there or undefined height add 0 only */ +
                        PreChatHeight /* PreChat Circle invitation height */ +
                        addedHeight /* Padding and shadow etc. extra height */ +
                        (args.isErrorMsgForFT ? args.errorMsgHeight : 0); // Error msg expected hight
                    // updating heights with expected height.
                    if (!me.initHeight) {
                        me.initHeight = expectedHeight;
                    } else if (expectedHeight !== me.initHeight) {
                        me.newHeight = expectedHeight;
                    }
                    if (!args.isResetIframe && expectedHeight === me.initHeight) return;
                    if (me.newHeight && me.initHeight) {
                        expectedHeight = me.newHeight;
                    }

                    TempCache.PRECHAT_Rounded_Message_Popup_Last_Height =
                        expectedHeight - PreChatHeight + addedHeight;
                    TempCache.PRECHAT_Rounded_Message_Popup_Current_Height =
                        expectedHeight - PreChatHeight + addedHeight;
                    // applying CSS for Height
                    // Animate the height of the container
                    // me.$container.style.transition = 'height 0.1s'; // causing jerk effect
                    me.$container.style.height = `${expectedHeight}px`; // Set the new height


                    // Animate the height of the iframe
                    // iframe.style.transition = 'height 0.1s'; // causing jerk effect
                    iframe.style.height = `${expectedHeight}px`; // Set the new height
                    const calculatedPosition =
                        expectedHeight -
                        closeButton.height -
                        parseInt(args.prevMsgHeight || extraHeightForSingleMsg) -
                        parseInt(args.prevMsgHeight ? addedHeight : 0) +
                        closeButton.padding;
                    // const closeElement = me.$(
                    //     '#apexchat_prechat_rd_close_btn_icon',
                    //     iframe.contentDocument
                    // );
                    const closeElement = iframe.contentDocument.querySelector(
                        '#apexchat_prechat_rd_close_btn_icon'
                    );
                    // we need to check in some cases  If this flag is TRUE we need to hide all prechat messages.
                    if (
                        args.hidePreChatMessages &&
                        iframe.contentDocument.querySelector('.apexchat_prechat_message_bubble')
                    ) {
                        iframe.contentDocument.querySelector(
                            '.apexchat_prechat_message_bubble'
                        ).style.display = 'none';
                    }
                    /* Improved logic of hiding Close button as we dont need to show close button when its not supports i.e in DEFAULT animation
                    hideClosebutton: In case of CLOSE button Press
                    isClosebuttonSupported: If its not supported in case of Default animation.
                    */
                    if (
                        (args.hideCloseButton || !closeButton.isCloseButtonSupported) &&
                        closeElement
                    ) {
                        closeElement.style.display = 'none';
                    } else {
                        closeElement.style.display = 'block';
                        /* Stacking-based animation supports Close button & dontAnimateCloseButton in some scenarios. */
                        if (closeButton.isCloseButtonSupported && !args.dontAnimateClosebutton) {
                            closeElement.animate({ bottom: calculatedPosition }, 200);
                        }
                    }
                    me.PreChatDefaultWidth = me.PreChatDefaultWidth || getStyle(iframe, 'width');

                    if (me.PreChatDefaultWidth.replace('px', '') > 320) {
                        me.PreChatDefaultWidth = '320px';
                    }
                    if (me.options.videoGreetEnabled) {
                        me.$(
                            '#apexchat_prechat_message_popup_container',
                            iframe.contentDocument
                        ).addClass('apexchat_prechat_message_popup_videogreet_enabled');
                    }
                    if (args.isResetIframe) {
                        const minimizedHeight =
                            PreChatHeight && PreChatHeight > 110 ? '110px' : `${PreChatHeight}px`;
                        const minimizedWidth =
                            PreChatWidth && PreChatWidth > 110
                                ? '110px'
                                : `${PreChatWidth - padding}px`;
                        iframe.style.width = minimizedWidth;
                        iframe.style.height = minimizedHeight;
                        me.$container.style.width = minimizedWidth;
                        me.$container.style.height = minimizedHeight;
                        me.$container.style.zIndex = '9999999999';
                    } else {
                        if (iframe) iframe.style.width = me.PreChatDefaultWidth;
                        me.$container.style.width = me.PreChatDefaultWidth;
                    }

                } catch (e) {
                    logIt(e);
                }
            });
            this.subscribe('prechat-size', (args) => {
                const iframe = document.getElementById(me.iframeId);
                let addValueWidth;
                let addValueHeight;
                if (me.options.isPreChatRoundedTheme) {
                    addValueWidth = args.addValue + 80;
                } else {
                    addValueWidth = args.addValue;
                    addValueHeight = args.addValue;
                }
                iframe.style.width = `${args.width + addValueWidth}px`;
                iframe.style.height = `${args.height + addValueHeight}px`;
                me.$container.style.width = `${args.width + addValueWidth}px`;
                me.$container.style.height = `${args.height + addValueHeight}px`;
                me.positioner.position({
                    element: me.parentDivId,
                    widgetType: WidgetTypes.PreChat,
                    position: me.options.preChat.preChatPosition
                });
                if (args.onCreateSizing) {
                    me.animator.animate({
                        element: me.iframeId,
                        widgetType: WidgetTypes.PreChat,
                        isPageRefreshed: me.isPageRefreshed()
                    });
                    me.animator.animate({
                        element: me.parentDivId,
                        widgetType: WidgetTypes.PreChat,
                        isPageRefreshed: me.isPageRefreshed()
                    });
                    window.setTimeout(() => {
                        me.$container.style.visibility = 'visible';
                    }, 200);
                    if (me.options.wiggleEnabled) {
                        me.setupWiggling();
                    }
                }
            });
            this.subscribe(WidgetTypes.PreChat + WidgetStates.Hidden, (args) => {
                me.$container.style.display = 'none';

                // PreChat Iframe should be Resize on PreChat hide, CASE: If someone clicks on PreChat circle instead of msgs.
                me.postMessage({
                    event: 'prechat-auto-resizing',
                    data: {
                        isResetIframe: true,
                        isSingleMsg: true,
                        hideCloseButton: true // we need to hide close button
                    }
                });
            });
            this.subscribe(WidgetTypes.PreChat + WidgetStates.ShownMaximized, (args) => {
                const DDState = me.state.getStateValue(WidgetTypes.DropDown);
                if (DDState == WidgetStates.ShownMinimized) {
                    return;
                }
                me.$container.style.display = 'block';
                if (me.options.videoGreetEnabled) {
                    const iframe = document.getElementById(me.iframeId);
                    if (iframe) {
                        me.$('#apexchat_prechat_message_popup', iframe.contentDocument).css("display", "none");
                    }
                    me.$container.style.visibility = 'visible';
                }
                me.positioner.position({
                    element: me.parentDivId,
                    widgetType: WidgetTypes.PreChat,
                    position: me.options.preChat.preChatPosition
                });
            });
            this.create();
        }

        create() {
            super.create();
            const self = this;
            addStyleText(this.options.invitationWidgetStyleCustom, 'test_css');
            self.$container.innerHTML = `<iframe class="${self.widget}_frame ${self.widget
                }_iframe_custom" id="${self.iframeId
                }" width="${500}" height="${500}" style="border: none;display: block;overflow-x:hidden; overflow-y:hidden;" marginheight="0" marginwidth="0" frameBorder="0" scrolling="no" horizontalscrolling="no" verticalscrolling="no"  allowtransparency="true" title="Chat Invitation"></iframe>`;
            document.body.appendChild(self.$container);

            self.$container.style.cssText = `margin: 10px;visibility: hidden; overflow:hidden; position: fixed; z-index:${TempCache.CONTAINER_Z_INDEX}; padding: 0px 10px 0px 0px`;
            if (self.options && self.options.videoGreetEnabled) {
                self.$container.style.cssText += ' display: none !important';
            }
            self.show();
            if (self.options.preChat.preChatMarginFromBottom) {
                self.$container.style.marginBottom = `${self.options.preChat.preChatMarginFromBottom}px`;
            }
            // getStyleForIframe(
            //     `${GlobalVariables.CdnBaseUrl}contents/scripts/dist/PreChatInvitation.css.css`,
            //     'prechat-responsive',
            //     'apexchat_prechat_invitation_frame'
            // );
        }

        show() {
            super.show();
        }
    };

    const _fq_name = `${WidgetTypes.PreChat}_client`;
    // Export to window
    createNS(_fq_name, PreChat);
}
